import page from '../../../constants/pages/page';
export const sortedKeyMap = { created_at_time: 'id' };
export const defaultSorted = [{ dataField: 'id', order: 'desc' }];
export const initialFilter = {
    filters: null,
    sortOrder: 'desc',
    sortField: 'id',
    pageNumber: page.pageNumber,
    pageSize: page.pageSize
};
